import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelListHeaderPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { Button } from "@website/ui/button";
import { Switch } from "@website/ui/switch";
import { deepCompare } from "@website/utils/deep-compare";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { HotelFilterChips } from "@website/widget/filter";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { FC, memo } from "react";

const Component: FC<HotelListHeaderPropertiesType> = (properties) => {
  const router = useRouter();
  const {
    loading,
    totalItem,
    city,
    sortProperties,
    selectedFiltersCount,
    setFilterOpen,
    hasFilter = true,
    hasCityPrefix = true,
    children,
    chipsFiltersSchema,
    hasCityNearby
  } = properties;

  const buttonProperties = {
    variant: "round-outline" as const,
    color: selectedFiltersCount ? ("secondary" as const) : ("neutral" as const),
    size: "small" as const,
    StartIcon: <MaterialIcon className="text-sm" name="tune" />,
    children: selectedFiltersCount
      ? `فیلترها (${numberConvert(selectedFiltersCount, {
          locale: router.locale
        })})`
      : "فیلترها",
    onClick: () => setFilterOpen && setFilterOpen((state) => !state)
  };

  return (
    <>
      <div className="lg:border-outline-thin bg-on-color-high-emphasis -mx-6 flex flex-wrap items-center justify-between gap-2 overflow-auto border border-b-0 p-3 px-5 lg:m-0 lg:overflow-visible lg:rounded-lg lg:border-b lg:bg-transparent lg:px-3">
        <div className="-mt-5 hidden lg:mt-0 lg:block">
          <HotelCityTitle
            city={city}
            hasCityPrefix={hasCityPrefix}
            loading={loading}
            totalItem={totalItem}
          />
        </div>
        <div className="flex justify-start gap-2">
          {hasCityNearby &&
            getTracking()?.experiment?.experiment_nearby_cities_toggle ===
              "true" && (
              <Switch
                key={`nearby=${router.query?.["nearby"]}`}
                name="nearby"
                label="نمایش ویلاهای اطراف"
                checked={Boolean(router.query?.["nearby"])}
                onChange={() =>
                  router.replace(
                    {
                      query: deepOmit(
                        {
                          ...omit(router.query, ["geo_property_summary"]),
                          nearby: !router.query?.["nearby"] || undefined
                        },
                        isFilled
                      )
                    },
                    undefined,
                    { shallow: true, scroll: false }
                  )
                }
                color="secondary"
                className="!text-body-2 !hidden flex-row-reverse !items-center !p-0 lg:!flex"
              />
            )}
          {hasFilter && (
            <div className="xl:hidden">
              <Button className="!whitespace-nowrap" {...buttonProperties} />
            </div>
          )}
          <HotelSortView {...sortProperties} />
          {children}
          {chipsFiltersSchema && (
            <HotelFilterChips
              chipsFiltersSchema={chipsFiltersSchema}
              classname="block md:hidden"
            />
          )}
        </div>
      </div>
    </>
  );
};

export const HotelListHeader = memo(Component, deepCompare);
